<template>
  <v-container>
    <cadastroDbGrid v-if="edit" @editItem="editItem" />
    <cadastroDbForm v-else :tenantUpdating="tenant" @editItem="editItem" />
  </v-container>
</template>

<script>
import cadastroDbGrid from './grid'
import cadastroDbForm from './form'

export default {
  name: 'CadastroDB',

  data: () => ({
    edit: true,
    tenant: ''
  }),

  components: {
    cadastroDbGrid,
    cadastroDbForm
  },

  methods: {
    editItem (boolean, item) {
      this.edit = boolean
      this.tenant = item?.tenant
    }
  }
}
</script>
